<template>
<div>
<h2>SVG Below</h2>
   <!-- :width="width"
        :height="height" -->

    <svg v-html="getContent()" width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg">



    </svg>
</div>
</template>

<script>
export default {
    components: { },
    name: "SVGTest",
    props:{
    },
    data() {
            return {
                width:'500px',
                height:'200px',
            }

        },
    mounted(){

    },

    methods:{
        getContent() {
            var rects = `<circle cx="500" cy="50" r="40" stroke="black" stroke-width="2" fill="red"/>`;
            var rectsplus = '';
            var yeardays = '';
            for(var ex=12; ex <=500; ex+=13) {
                for(var vi=12; vi <=1500; vi+=13) {
                    rectsplus +=  `<rect x="`+ex+ `" y="`+ vi +`" width="11" height="11" rx="0" ry="0" style="fill:#eee;"/>`;
                }

            }
            for(var week=1; week <=52; week++) {
                    for(var day=1; day <=7; day++) {
                    // vi = (week* day * 13) -1;
                    // ex= week* 27;
                        vi = day * 13 - 1;
                        ex = week * 13 +14;
                    var row = `<rect x="`+ex+ `" y="`+ vi +`" width="11" height="11" rx="0" ry="0" style="fill:#eee;"/>`;
                    console.log(row);
                yeardays +=  row;
                }
            }

var daysofweek=`<text x="12" y="98" style="fill:#444;text-anchor:middle;text-align:center;font:9px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:display;"><tspan x="12" dy="0em">S</tspan></text>
<text x="12" y="18" style="fill:#444;text-anchor:middle;text-align:center;font:9px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:display;"><tspan x="12" dy="0em">S</tspan></text>
<text x="12" y="31" style="fill:#ccc;text-anchor:middle;text-align:center;font:9px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:display;"><tspan x="12" dy="0em">M</tspan></text>
<text x="12" y="44" style="fill:#ccc;text-anchor:middle;text-align:center;font:9px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:display;"><tspan x="12" dy="0em">T</tspan></text>
<text x="12" y="57" style="fill:#ccc;text-anchor:middle;text-align:center;font:9px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:display;"><tspan x="12" dy="0em">W</tspan></text>
<text x="12" y="70" style="fill:#ccc;text-anchor:middle;text-align:center;font:9px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:display;"><tspan x="12" dy="0em">T</tspan></text>
<text x="12" y="83" style="fill:#ccc;text-anchor:middle;text-align:center;font:9px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:display;"><tspan x="12" dy="0em">F</tspan></text>`;

            console.log(yeardays);
var mths=`<text x="40" y="9" style="fill:#555;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="27" dy="0em">Jan</tspan></text>
<text x="92" y="9" style="fill:#aaa;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="92" dy="0em">Feb</tspan></text>
<text x="157" y="9" style="fill:#555;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="157" dy="0em">Mar</tspan></text>
<text x="222" y="9" style="fill:#aaa;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="222" dy="0em">Apr</tspan></text>
<text x="274" y="9" style="fill:#555;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="274" dy="0em">May</tspan></text>
<text x="339" y="9" style="fill:#aaa;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="339" dy="0em">Jun</tspan></text>
<text x="391" y="9" style="fill:#555;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="391" dy="0em">Jul</tspan></text>
<text x="443" y="9" style="fill:#aaa;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="443" dy="0em">Aug</tspan></text>
<text x="508" y="9" style="fill:#555;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="508" dy="0em">Sep</tspan></text>
<text x="560" y="9" style="fill:#aaa;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="560" dy="0em">Oct</tspan></text>
<text x="612" y="9" style="fill:#555;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="612" dy="0em">Nov</tspan></text>
<text x="677" y="9" style="fill:#aaa;text-align:center;font:10px Helvetica, arial, freesans, clean, sans-serif;white-space:nowrap;display:block;"><tspan x="677" dy="0em">Dec</tspan></text>`;

            // return `<circle cx="500" cy="50" r="40" stroke="black" stroke-width="2" fill="red"/>
            //         <rect x="12" y="27" width="11" height="11" rx="0" ry="0" style="fill:#000;"/>
            //         <rect x="25" y="27" width="11" height="11" rx="0" ry="0" style="fill:#111;"/>
            //         <rect x="38" y="27" width="11" height="11" rx="0" ry="0" style="fill:#222;"/>
            //         <rect x="51" y="27" width="11" height="11" rx="0" ry="0" style="fill:#333;"/>`;
            return rects + yeardays + daysofweek + mths;

        },

    }
}

</script>
